module.exports = __webpack_public_path__ + "static/media/nodejs.f8dab57d.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/nodejs.png
// module id = 496
// module chunks = 0